import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { last } from '@angular/router/src/utils/collection';
import { AngularFireDatabase } from 'angularfire2/database';

@Injectable()
export class BrowseListService {

  browseFokos: Observable<any[]>;

  glossariesLoaded = 10;

  GLOSSARIES_TO_LOAD = 1;

  getFokos(batch, lastKey?) {
    if (lastKey) {
      return this.database.list('codes', ref => ref.orderByKey().limitToFirst(batch).startAt(lastKey));
    }
    return this.database.list('codes', ref => ref.orderByKey().limitToFirst(batch));
  }

  constructor(public database: AngularFireDatabase) {
    console.log('BrowseListService is instantiated');
    this.browseFokos = database.list('codes', ref => ref.orderByChild('views').limitToFirst(this.glossariesLoaded)).snapshotChanges();
  }

  loadMore() {
    this.glossariesLoaded += 10;
    console.log("loading more ");
    this.browseFokos = this.database.list('codes', ref => ref.orderByChild('views').limitToFirst(10)).snapshotChanges();
  }

}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/services/browse-list.service.ts